module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/indicater-b12330b9da5a5c4409187a30ce91d814.png";